"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "settings-locked-notice"
};
const _hoisted_2 = { class: "settings-wrapper" };
const _hoisted_3 = { key: 5 };
const DashboardContentTab_vue_1 = __importDefault(require("./DashboardContentTab.vue"));
const SettingsShiftContent_vue_1 = __importDefault(require("./SettingsShiftContent.vue"));
const SettingsTimecardContent_vue_1 = __importDefault(require("./SettingsTimecardContent.vue"));
const SettingsBrowserContent_vue_1 = __importDefault(require("./SettingsBrowserContent.vue"));
const SettingsOEMContent_vue_1 = __importDefault(require("./SettingsOEMContent.vue"));
const MaxLaborPerMonthModal_vue_1 = __importDefault(require("../MaxLaborPerMonthModal.vue"));
const SaveConfirmModal_vue_1 = __importDefault(require("./SaveConfirmModal.vue"));
const vue_3 = require("vue");
const settingsRequest_1 = require("../../requests/settingsRequest");
const settings_js_1 = require("../../js/settings.js");
const branchSettingsParser_1 = require("../../parser/branchSettingsParser");
const branchSettings_1 = require("../../model/v1/branchSettings");
const timeZones_1 = __importDefault(require("../../common/timeZones"));
const PtoConfig_vue_1 = __importDefault(require("../../pto/components/PtoConfig.vue"));
const ChatSettings_vue_1 = __importDefault(require("../../view/components/chatSettings/ChatSettings.vue"));
const apiError_1 = require("../../webappApi/v2/model/apiError");
const SettingsOthersContent_vue_1 = __importDefault(require("./SettingsOthersContent.vue"));
const common_1 = require("../../common/common");
const GROUP_SETTINGS_MAX_TAB = 6;
const BRANCH_SETTINGS_MAX_TAB = 2;
// MAIN SETTINGS
exports.default = (0, vue_1.defineComponent)({
    __name: 'Settings',
    props: {
        meStore: {
            type: Object,
            required: true
        },
        activeBranch: {
            type: Object,
            required: true
        },
        activeGroup: {
            type: Object,
            required: true
        },
        isDefaultSettingsPage: {
            type: Boolean
        },
        permissions: {
            type: Object,
            required: true,
        },
        hidePTO: {
            type: Boolean,
            default: false,
        },
        hideTime: {
            type: Boolean,
            default: false,
        },
        showTzSetting: {
            type: Boolean,
            default: false,
        }
    },
    setup(__props) {
        const props = __props;
        // check settingsPageParams object:
        // 6 is max index tab as of group settings 2025-01-11
        // 2 is max index tab for branch settings
        const hasTrialPerm = props.permissions.branch.hasTrial;
        const hasProPerm = props.permissions.branch.hasPro;
        const hasTimePerm = props.permissions.branch.hasTime;
        const hasAutoPerm = props.permissions.branch.hasAuto;
        const hasPathosLogosPerm = props.permissions.group.hasPathosLogos;
        const hasCCBizPerm = props.permissions.group.hasCCBiz;
        const hasPtoPerm = props.permissions.group.hasPTO;
        const hasKotPerm = props.permissions.group.hasKOT;
        const hasSmartHRPerm = props.permissions.group.hasSmartHR;
        const branchPermissions = Object.freeze({
            hasTrialPerm: hasTrialPerm,
            hasProPerm: hasProPerm,
            hasTimePerm: hasTimePerm,
            hasAutoPerm: hasAutoPerm,
            hasPathosLogosPerm: hasPathosLogosPerm,
            hasCCBizPerm: hasCCBizPerm,
            hasPtoPerm: hasPtoPerm,
            hasKotPerm: hasKotPerm,
            hasSmartHRPerm: hasSmartHRPerm,
        });
        const settingsPageParams = Object.freeze({
            shifts: {
                param: "shift",
                tabText: "シフト",
            },
            timecard: {
                param: "timecard",
                tabText: "勤怠",
            },
            browser: {
                param: "browser",
                tabText: "ブラウザー",
            },
            ptoConfig: {
                param: "pto",
                tabText: "有休",
            },
            oem: {
                param: "oem",
                tabText: "連携",
            },
            chat: {
                param: "chat",
                tabText: "チャット",
            },
            others: {
                param: "others",
                tabText: "その他",
            }
            // make sure to update initTab() function when adding more settings tab
        });
        const reactiveBranch = (0, vue_3.ref)(props.activeBranch);
        const isLoading = (0, vue_3.ref)(false);
        const isUpdating = (0, vue_3.ref)(false);
        const saveConfirmModal = (0, vue_3.ref)(null);
        // Tabs
        const shiftContent = (0, vue_3.ref)(null);
        const timecardContent = (0, vue_3.ref)(null);
        const browserContent = (0, vue_3.ref)(null);
        const ptoContent = (0, vue_3.ref)(null);
        const chatContent = (0, vue_3.ref)(null);
        const oemContent = (0, vue_3.ref)(null);
        const shouldSkipBeforeUnload = (0, vue_3.ref)(false);
        const maxLaborPerMonthModal = (0, vue_3.ref)(null);
        const branchCanEditSettings = (0, vue_3.computed)(() => {
            return reactiveBranch.value.canEditSettings;
        });
        const ptoConfig = (0, vue_3.computed)(() => {
            return props.activeGroup.getGroupSettings().getPtoConfig();
        });
        const activeBranchId = (0, vue_3.computed)(() => {
            return props.meStore.getActiveBranchId();
        });
        const activeGroupId = props.activeGroup.getId();
        const activeUserId = (0, vue_3.computed)(() => {
            return props.meStore.getActiveUserId();
        });
        function openMaxLaborPerMonthModal() {
            maxLaborPerMonthModal.value?.openModal();
        }
        function updateSettings(newSettings) {
            reactiveBranch.value.setSettings(newSettings);
        }
        async function fetchSettings() {
            try {
                let branchSettings;
                isLoading.value = true;
                if (branchCanEditSettings.value && !props.isDefaultSettingsPage) {
                    branchSettings = await (0, settingsRequest_1.getBranchSettings)(activeBranchId.value);
                }
                else {
                    branchSettings = await (0, settingsRequest_1.getDefaultBranchSettings)(activeGroupId);
                }
                updateSettings(branchSettings);
            }
            catch (err) {
                throw err;
            }
            finally {
                isLoading.value = false;
            }
        }
        // Update shift settings
        async function putBranchShiftSettings(localBranchSettingsData) {
            try {
                isUpdating.value = true;
                const tz = props.showTzSetting && localBranchSettingsData.timeZone ? localBranchSettingsData.timeZone : timeZones_1.default.ASIA_TOKYO;
                let settings = new branchSettings_1.BranchSettings({ timeZone: tz });
                const rawData = (0, branchSettingsParser_1.parseShiftSettingsToRaw)(props.activeBranch, localBranchSettingsData);
                if (!props.isDefaultSettingsPage) {
                    settings = await (0, settingsRequest_1.updateBranchShiftSettings)(activeBranchId.value, rawData);
                }
                else {
                    settings = await (0, settingsRequest_1.updateBranchDefaultShiftSettings)(activeGroupId, rawData);
                }
                updateSettings(settings);
                (0, common_1.showSaveSuccessSnackbar)();
                shiftContent.value?.updateSaved();
                return true;
            }
            catch (err) {
                let alertText = String(err);
                if (err instanceof apiError_1.ApiError && err.detail.trim() === "input text too long") {
                    alertText = `全角/半角のひらがな/カタカナ及び全角漢字/英数は3文字以内で、半角英数は10文字以内で、ご入力ください。`;
                }
                (0, settings_js_1.importAlertModal)().alert(alertText);
                return false;
            }
            finally {
                isUpdating.value = false;
            }
        }
        // Update timecard settings
        async function putTimecardSettings(localBranchSettingsData) {
            try {
                isUpdating.value = true;
                const tz = props.showTzSetting ? reactiveBranch.value.getSettings().timeZone : timeZones_1.default.ASIA_TOKYO;
                let settings = new branchSettings_1.BranchSettings({ timeZone: tz });
                const rawData = (0, branchSettingsParser_1.parseTimecardSettingsToRaw)(props.activeBranch, localBranchSettingsData);
                if (!props.isDefaultSettingsPage) {
                    settings = await (0, settingsRequest_1.updateBranchTimecardSettings)(activeBranchId.value, rawData);
                }
                else {
                    settings = await (0, settingsRequest_1.updateBranchTimecardDefaultSettings)(activeGroupId, rawData);
                }
                updateSettings(settings);
                (0, common_1.showSaveSuccessSnackbar)();
                timecardContent.value?.updateSaved();
                return true;
            }
            catch (err) {
                (0, settings_js_1.importAlertModal)().alert(err);
                return false;
            }
            finally {
                isUpdating.value = false;
            }
        }
        const settingsTabs = (0, vue_3.computed)(() => {
            const tabs = [
                settingsPageParams.shifts,
                ...(!props.hideTime ? [settingsPageParams.timecard] : []),
                settingsPageParams.browser,
            ];
            if (props.isDefaultSettingsPage) {
                if (!props.hidePTO) {
                    tabs.push(settingsPageParams.ptoConfig);
                }
                tabs.push(settingsPageParams.oem, settingsPageParams.chat, settingsPageParams.others);
            }
            return tabs;
        });
        const tabItemTexts = (0, vue_3.computed)(() => {
            return settingsTabs.value.map(tab => tab.tabText);
        });
        function getTabIndex(tabParam) {
            return settingsTabs.value.findIndex(tab => tab.param === tabParam);
        }
        const activeTabIndex = (0, vue_3.ref)(getTabIndex(settingsPageParams.shifts.param) ?? 0);
        function replaceURLTabParam(selectedTabIndex) {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.searchParams);
            if (props.isDefaultSettingsPage) {
                params.set('branch-default', 'true');
            }
            params.set('tab', selectedTabIndex.toString());
            params.set('c', props.meStore.getActiveBranchId());
            url.search = params.toString();
            if (window.history.pushState) {
                window.history.pushState({}, "", url);
            }
            else if (window.history.replaceState) {
                window.history.replaceState({}, "", url);
            }
        }
        function switchTab(selectedTabIndex) {
            activeTabIndex.value = selectedTabIndex;
            replaceURLTabParam(selectedTabIndex);
        }
        function handleSelectedTab(selectedTabIndex) {
            if (selectedTabIndex === activeTabIndex.value) {
                return;
            }
            const saveState = getSaveState();
            if (saveState) {
                openSaveConfirmModal(saveState.save, () => switchTab(selectedTabIndex));
                return;
            }
            switchTab(selectedTabIndex);
        }
        function handleShiftSettingsEmit(data) {
            putBranchShiftSettings(data.value);
        }
        function handleTimecardSettingsEmit(data) {
            putTimecardSettings(data.value);
        }
        (0, vue_3.onBeforeMount)(async () => {
            try {
                activeTabIndex.value = initTab();
                replaceURLTabParam(activeTabIndex.value);
                await fetchSettings();
            }
            catch (err) {
                (0, settings_js_1.importAlertModal)().alert(err);
            }
        });
        function initTab() {
            const tab = Number(new URL(window.location.href).searchParams.get('tab'));
            const maxTab = props.isDefaultSettingsPage ? GROUP_SETTINGS_MAX_TAB : BRANCH_SETTINGS_MAX_TAB;
            if (!tab || tab > maxTab || tab < 0) {
                return 0;
            }
            return tab;
        }
        function openSaveConfirmModal(saveCallback, redirectCallback, delayMs = 0) {
            saveConfirmModal.value?.openModal(saveCallback, redirectCallback, delayMs);
        }
        function handleBeforeUnload(event) {
            if (shouldSkipBeforeUnload.value) {
                return;
            }
            const saveState = getSaveState();
            if (!saveState) {
                return;
            }
            event.preventDefault();
        }
        function getSaveState() {
            if (isShiftSettingsActive.value && shiftContent.value?.hasUnsavedChanges()) {
                return {
                    save: async () => {
                        const settings = shiftContent.value?.getSettingsForSubmit();
                        if (!settings) {
                            return false;
                        }
                        return await putBranchShiftSettings(settings);
                    },
                };
            }
            if (isTimecardSettingsActive.value && timecardContent.value?.hasUnsavedChanges()) {
                return {
                    save: async () => {
                        const settings = timecardContent.value?.getSettingsForSubmit();
                        if (!settings) {
                            return false;
                        }
                        return await putTimecardSettings(settings);
                    },
                };
            }
            if (isBrowserSettingsActive.value && browserContent.value?.hasUnsavedChanges()) {
                return {
                    save: browserContent.value.saveSettings,
                };
            }
            if (isPtoConfigActive.value && ptoContent.value?.hasUnsavedChanges()) {
                return {
                    save: ptoContent.value.saveSettings,
                };
            }
            if (isChatSettingsActive.value && chatContent.value?.hasUnsavedChanges()) {
                return {
                    save: chatContent.value.saveSettings,
                };
            }
            if (isOEMSettingsActive.value && oemContent.value?.hasUnsavedChanges()) {
                return {
                    save: oemContent.value.saveSettings,
                };
            }
            return null;
        }
        function redirectWithoutBeforeUnload(url) {
            shouldSkipBeforeUnload.value = true;
            window.location.href = url;
        }
        function handlePageLinkClick(event) {
            const url = (0, common_1.getLinkUrlFromClickEvent)(event);
            if (!url) {
                return;
            }
            const saveState = getSaveState();
            if (!saveState) {
                return;
            }
            event.preventDefault();
            openSaveConfirmModal(saveState.save, () => redirectWithoutBeforeUnload(url), 600);
        }
        const computedBranchSettings = (0, vue_3.computed)(() => {
            return reactiveBranch.value.getSettings();
        });
        const shiftSettings = (0, vue_3.computed)(() => {
            return computedBranchSettings.value.getShiftSettings();
        });
        const timecardSettings = (0, vue_3.computed)(() => {
            return computedBranchSettings.value.getTimecardSettings();
        });
        const integrationSettings = (0, vue_3.computed)(() => {
            return props.activeGroup.getGroupSettings().getIntegrationSettings();
        });
        const isShiftSettingsActive = (0, vue_3.computed)(() => {
            return activeTabIndex.value === getTabIndex(settingsPageParams.shifts.param);
        });
        const isTimecardSettingsActive = (0, vue_3.computed)(() => {
            return activeTabIndex.value === getTabIndex(settingsPageParams.timecard.param) && !props.hideTime;
        });
        const isBrowserSettingsActive = (0, vue_3.computed)(() => {
            return activeTabIndex.value === getTabIndex(settingsPageParams.browser.param);
        });
        const isPtoConfigActive = (0, vue_3.computed)(() => {
            return activeTabIndex.value === getTabIndex(settingsPageParams.ptoConfig.param) && !props.hidePTO;
        });
        const isOEMSettingsActive = (0, vue_3.computed)(() => {
            return activeTabIndex.value === getTabIndex(settingsPageParams.oem.param);
        });
        const isChatSettingsActive = (0, vue_3.computed)(() => {
            return activeTabIndex.value === getTabIndex(settingsPageParams.chat.param);
        });
        const isOthersSettingsActive = (0, vue_3.computed)(() => {
            return activeTabIndex.value === getTabIndex(settingsPageParams.others.param);
        });
        (0, vue_3.onMounted)(() => {
            window.addEventListener("beforeunload", handleBeforeUnload);
            window.addEventListener('click', handlePageLinkClick, true);
        });
        (0, vue_3.onBeforeUnmount)(() => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            window.removeEventListener('click', handlePageLinkClick, true);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(SaveConfirmModal_vue_1.default, {
                    ref_key: "saveConfirmModal",
                    ref: saveConfirmModal
                }, null, 512 /* NEED_PATCH */),
                (0, vue_2.createCommentVNode)(" Tabs "),
                (0, vue_2.createVNode)(DashboardContentTab_vue_1.default, {
                    "tab-item-texts": tabItemTexts.value,
                    "active-tab-index": activeTabIndex.value,
                    onEmitTabIndex: handleSelectedTab
                }, null, 8 /* PROPS */, ["tab-item-texts", "active-tab-index"]),
                (0, vue_2.createVNode)(MaxLaborPerMonthModal_vue_1.default, {
                    ref_key: "maxLaborPerMonthModal",
                    ref: maxLaborPerMonthModal,
                    "group-id": (0, vue_2.unref)(activeGroupId)
                }, null, 8 /* PROPS */, ["group-id"]),
                (!branchCanEditSettings.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
                            (0, vue_2.createElementVNode)("span", { class: "text-error" }, " 設定マスターの設定が反映されています。設定内容を変更されたい場合は、オーナー権限をお持ちの方へご連絡をお願いいたします。 ", -1 /* CACHED */)
                        ]))]))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (isShiftSettingsActive.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SettingsShiftContent_vue_1.default, {
                            key: 0,
                            ref_key: "shiftContent",
                            ref: shiftContent,
                            onEmitShiftSettings: handleShiftSettingsEmit,
                            onEmitOpenBranchMaxLaborModal: openMaxLaborPerMonthModal,
                            "shift-settings": shiftSettings.value,
                            permissions: (0, vue_2.unref)(branchPermissions),
                            "is-loading": isLoading.value,
                            "is-updating": isUpdating.value,
                            "branch-can-edit-settings": branchCanEditSettings.value,
                            "is-default-settings-page": __props.isDefaultSettingsPage,
                            "selected-oem": __props.activeGroup.getGroupSettings().getSelectedOem(),
                            "show-tz-setting": props.showTzSetting
                        }, null, 8 /* PROPS */, ["shift-settings", "permissions", "is-loading", "is-updating", "branch-can-edit-settings", "is-default-settings-page", "selected-oem", "show-tz-setting"]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (isTimecardSettingsActive.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SettingsTimecardContent_vue_1.default, {
                            key: 1,
                            ref_key: "timecardContent",
                            ref: timecardContent,
                            onEmitTimecardSettings: handleTimecardSettingsEmit,
                            "timecard-settings": timecardSettings.value,
                            permissions: (0, vue_2.unref)(branchPermissions),
                            "is-loading": isLoading.value,
                            "is-updating": isUpdating.value,
                            "branch-can-edit-settings": branchCanEditSettings.value,
                            "is-default-settings-page": __props.isDefaultSettingsPage
                        }, null, 8 /* PROPS */, ["timecard-settings", "permissions", "is-loading", "is-updating", "branch-can-edit-settings", "is-default-settings-page"]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (isBrowserSettingsActive.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SettingsBrowserContent_vue_1.default, {
                            key: 2,
                            ref_key: "browserContent",
                            ref: browserContent
                        }, null, 512 /* NEED_PATCH */))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (__props.isDefaultSettingsPage && isPtoConfigActive.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(PtoConfig_vue_1.default, {
                            key: 3,
                            ref_key: "ptoContent",
                            ref: ptoContent,
                            "pto-config-prop": ptoConfig.value,
                            "me-store": __props.meStore,
                            permissions: (0, vue_2.unref)(branchPermissions)
                        }, null, 8 /* PROPS */, ["pto-config-prop", "me-store", "permissions"]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (isChatSettingsActive.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ChatSettings_vue_1.default, {
                            key: 4,
                            ref_key: "chatContent",
                            ref: chatContent
                        }, null, 512 /* NEED_PATCH */))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createCommentVNode)(" Note: we hide this when the page is branch settings and not the group/default "),
                    (__props.isDefaultSettingsPage)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                            (0, vue_2.createCommentVNode)(" Use v-show instead of v-if so that the updated value won't reset "),
                            (0, vue_2.withDirectives)((0, vue_2.createVNode)(SettingsOEMContent_vue_1.default, {
                                ref_key: "oemContent",
                                ref: oemContent,
                                "integration-settings": integrationSettings.value,
                                "group-data": __props.activeGroup,
                                "me-store": __props.meStore,
                                permissions: (0, vue_2.unref)(branchPermissions)
                            }, null, 8 /* PROPS */, ["integration-settings", "group-data", "me-store", "permissions"]), [
                                [vue_2.vShow, isOEMSettingsActive.value]
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (isOthersSettingsActive.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SettingsOthersContent_vue_1.default, {
                            key: 6,
                            "is-default-settings-page": __props.isDefaultSettingsPage,
                            "user-id": activeUserId.value
                        }, null, 8 /* PROPS */, ["is-default-settings-page", "user-id"]))
                        : (0, vue_2.createCommentVNode)("v-if", true)
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
